import { Container, injected } from 'brandi';
import { TOKENS } from './tokens';
import {
  FirebaseAppointmentRepository,
  FirebaseDoctorRepository,
  FirebaseUserRepository,
  FirebasePatientRepository,
  FirebaseSpecialtyRepository
} from '../../infra/firebase/repositories';

export function bindRepositories(container: Container): Container {
  container.bind(TOKENS.userRepository).toInstance(FirebaseUserRepository).inTransientScope();

  container
    .bind(TOKENS.appointmentRepository)
    .toInstance(FirebaseAppointmentRepository)
    .inTransientScope();

  container.bind(TOKENS.doctorRepository).toInstance(FirebaseDoctorRepository).inTransientScope();
  injected(FirebaseDoctorRepository, TOKENS.specialtyService);

  container.bind(TOKENS.patientRepository).toInstance(FirebasePatientRepository).inTransientScope();

  container
    .bind(TOKENS.specialtyRepository)
    .toInstance(FirebaseSpecialtyRepository)
    .inTransientScope();

  return container;
}
